// extracted by mini-css-extract-plugin
export default {"footer":"Fotter_footer__0hc+t"};